import React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

const PREFIX = 'ChartTable';

const classes = {
  title: `${PREFIX}-title`,
  container: `${PREFIX}-container`,
  header: `${PREFIX}-header`,
  firstColumnHeader: `${PREFIX}-firstColumnHeader`,
  firstColumn: `${PREFIX}-firstColumn`,
  tableCell: `${PREFIX}-tableCell`
};

/*
[`& .${classes.container}`]: {
    maxHeight: 0.65 *  windowHeight,
  },
*/

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.title}`]: {
    textAlign: "center",
    marginBottom: "2%",
  },

  [`& .${classes.header}`]: {
    //colors! :)
    //backgroundColor: '#fda48c', //option 1
    backgroundColor: '#f09819', //option 2
    //backgroundColor: '#f4b65e', //option 3
    color: '#ffffff', //white letters
    //color: '#000000', //black letters
    whiteSpace: "nowrap",
    [theme.breakpoints.down('xs')]: {
      whiteSpace: "normal",
    },
    //borders
    borderRightStyle: "solid", 
    borderRightColor: "#e0e0e0",
    borderRightWidth: "thin",
  },

  [`& .${classes.firstColumnHeader}`]: {
    whiteSpace: "nowrap",
    [theme.breakpoints.down('xs')]: {
      whiteSpace: "normal",
    },
    //this 3 atributes are nesesary for the column to remain stuck to the left side.
    position: "sticky",
    left: 0,
    zIndex: 3, //makes the first header element remain on top of the other ones (because they have a z-index 2)
    //colors
    color: '#ffffff', //black letters
    backgroundColor: '#f09819', 
    //borders
    borderRightStyle: "solid", 
    borderRightColor: "#e0e0e0",
    borderRightWidth: "thin",
    
  },

  [`& .${classes.firstColumn}`]: {
    whiteSpace: "nowrap",
    [theme.breakpoints.down('xs')]: {
      whiteSpace: "normal",
    },
    //this 2 atributes are nesesary for the column to remain stuck to the left side.
    position: "sticky",
    left: 0,
    //colors
    color: '#000000', //black letters
    backgroundColor: '#ffffff',
    //borders
    borderRightStyle: "solid", 
    borderRightColor: "#e0e0e0",
    borderRightWidth: "thin",
  },

  //all the other cells
  [`& .${classes.tableCell}`]: {
    //borders
    borderRightStyle: "solid", 
    borderRightColor: "#e0e0e0",
    borderRightWidth: "thin"
  }
}));

function ChartTable(props) {
  const {
    windowHeight,
    title,
    tableHeader,
    tableRows
  } = props;



  return (
    <Root>
      <Typography className={classes.title} variant="h6">{title}</Typography>
      <TableContainer component={Paper} sx={{maxHeight: 0.65 *  windowHeight}}>
        <Table stickyHeader >
          <TableHead>
            <TableRow>
              {tableHeader.map(header_element => (
                <TableCell 
                  align="center" 
                  className={header_element.key == -1 ? classes.firstColumnHeader : classes.header}
                  key={header_element.key}
                >
                  {header_element.name}
                </TableCell>))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((row) => (
              <TableRow 
                key={row.key}
              >
                {row.rowData.map((element) => (
                  <TableCell
                   align="center" 
                   key={element.key}
                   className={element.key == 0 ? classes.firstColumn : classes.tableCell}
                  >
                    {element.name}
                  </TableCell>))
                }
              </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Root>
  );
}

export default ChartTable;